import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Radio/Radio.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Examples`}</h2>
    <Note variant="warning" mdxType="Note">
      <p><strong parentName="p">{`Use `}<a parentName="strong" {...{
            "href": "/FormControl"
          }}>{`FormControl`}</a>{` to render a standard radio input field.`}</strong>{` This component is only meant to be used in the case that you're building a custom radio that is not yet supported by Primer (For example: the color mode selection in `}<a parentName="p" {...{
          "href": "https://github.com/settings/appearance"
        }}>{`Appearance settings`}</a>{`)`}</p>
      <p>{`If you do use this component to build a custom radio, it should always be accompanied by a corresponding `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` to improve support for assistive technologies.`}</p>
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Radio value="one" name="radio-group-name" />
  <Radio value="two" name="radio-group-name" />
  <Radio disabled value="three" name="radio-group-name" />
</>
`}</code></pre>
    <Note mdxType="Note">
      <p>{`Please use a `}<a parentName="p" {...{
          "href": "/Checkbox"
        }}>{`Checkbox`}</a>{` if the user needs to select more than one option in a list`}</p>
    </Note>
    <h3>{`Grouping Radio components`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`name`}</inlineCode>{` prop to group together related `}<inlineCode parentName="p">{`Radio`}</inlineCode>{` components in a list.`}</p>
    <p>{`If you're not building something custom, you should use the `}<a parentName="p" {...{
        "href": "/RadioGroup"
      }}>{`RadioGroup`}</a>{` component to render a group of radio inputs.`}</p>
    <h4>{`Using `}<inlineCode parentName="h4">{`RadioGroup`}</inlineCode></h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<form>
  <RadioGroup name="radioGroup-example">
    <RadioGroup.Label>Choices</RadioGroup.Label>
    <FormControl>
      <Radio value="1" />
      <FormControl.Label>Radio 1</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="2" />
      <FormControl.Label>Radio 2</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="3" />
      <FormControl.Label>Radio 3</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio value="4" />
      <FormControl.Label>Radio 4</FormControl.Label>
    </FormControl>
  </RadioGroup>
</form>
`}</code></pre>
    <h4>{`Using `}<inlineCode parentName="h4">{`name`}</inlineCode>{` to group Radio components`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<form>
  <FormControl>
    <Radio value="1" name="radio-example" />
    <FormControl.Label>Radio 1</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="2" name="radio-example" />
    <FormControl.Label>Radio 2</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="3" name="radio-example" />
    <FormControl.Label>Radio 3</FormControl.Label>
  </FormControl>
  <FormControl>
    <Radio value="4" name="radio-example" />
    <FormControl.Label>Radio 4</FormControl.Label>
  </FormControl>
</form>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      